import { render } from "./search-filter.vue?vue&type=template&id=3b5fdb80"
import script from "./search-filter.vue?vue&type=script&lang=js"
export * from "./search-filter.vue?vue&type=script&lang=js"

import "./search-filter.vue?vue&type=style&index=0&id=3b5fdb80&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__